import { fetchPublicSettings } from './playApi.js';
import { injectGoogleAnalytics } from './googleAnalytics.js';

export function bootstrapAnalytics() {
  fetchPublicSettings().then((data) => {
    injectGoogleAnalytics(data?.settings?.googleAnalyticsId);
  });
}
